"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cosmos_1 = require("components/cosmos");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const dropzone_1 = require("components/dropzone");
const translate_1 = require("components/translate");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const player_1 = require("modules/app/services/datahub/player");
const ConfigService_1 = __importDefault(require("modules/configManager/ConfigService"));
const types_1 = require("modules/configManager/types");
const PlayerModal_1 = __importDefault(require("modules/player/components/PlayerModal"));
const ui_1 = require("modules/ui");
const UploadInfo_1 = __importDefault(require("./UploadInfo"));
const FileService_1 = __importDefault(require("../../FileService"));
const club_files_ui_1 = require("@hotmart/club-files-ui");
const FileVideoUpload = ({ maxFileSize, beforeSend, multiple, isConfigLoaded, reusable, entityType, fileUpload, hasStreamingActivationModal = false, fileLibraryProvider = types_1.FileLibraryProvider.Club, marketplaceId, t }) => {
    const [isModalOpen, setIsModalOpen] = react_1.default.useState(false);
    const [isStreaming, setIsStreaming] = react_1.default.useState(false);
    const [filesToUpload, setFilesToUpload] = react_1.default.useState(null);
    const [addOnCost, setAddOnCost] = react_1.default.useState('');
    const [bundleAddOnCost, setBundleAddOnCost] = react_1.default.useState('');
    const actionName = react_1.default.useRef('upload');
    const isACandidateToUseStreaming = hasStreamingActivationModal && !isStreaming;
    const dropzoneRef = react_1.default.useRef(null);
    const eventParamsObject = (action) => {
        return {
            marketplaceId,
            action
        };
    };
    react_1.default.useEffect(() => {
        const fetchStreamingCost = async () => {
            const streamingCost = await ConfigService_1.default.getStreamingCostConsideringStreamingCampaign();
            if (streamingCost) {
                setAddOnCost(streamingCost);
            }
        };
        if (isACandidateToUseStreaming) {
            fetchStreamingCost();
        }
    }, [isACandidateToUseStreaming]);
    react_1.default.useEffect(() => {
        const fetchBundleStreamingCost = async () => {
            const bundleStreamingCost = await ConfigService_1.default.getBundleStreamingCosts();
            if (bundleStreamingCost) {
                setBundleAddOnCost(bundleStreamingCost);
            }
        };
        if (isACandidateToUseStreaming) {
            fetchBundleStreamingCost();
        }
    }, [isACandidateToUseStreaming]);
    const openModalTrackingEvents = () => {
        player_1.DataHubPlayerService.openActivatePlayerModalEvent(eventParamsObject(actionName.current));
    };
    const cancelModalTrackingEvents = () => {
        player_1.DataHubPlayerService.cancelPlayerDeactivationOnContentPageEvent(eventParamsObject(actionName.current));
    };
    const confirmModalTrackingEvents = () => {
        player_1.DataHubPlayerService.confirmPlayerActivationOnContentPageEvent(eventParamsObject(actionName.current));
    };
    const activePlayerStreaming = async () => {
        await ConfigService_1.default.updateStreamingStatus({ active: true });
        ui_1.UiService.setAlertSuccess('done');
    };
    const openClubLibrary = () => {
        var _a, _b;
        (_b = (_a = fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.actions) === null || _a === void 0 ? void 0 : _a.openLibrary) === null || _b === void 0 ? void 0 : _b.call(_a, {
            onOpenLibrary: FileService_1.default.onLibraryOpen,
            customProvider: fileLibraryProvider === types_1.FileLibraryProvider.PlayerBackoffice
        });
    };
    const handleModalCancel = () => {
        setIsModalOpen(false);
        cancelModalTrackingEvents();
        setFilesToUpload(null);
    };
    const sendFilesToUpload = (items) => {
        var _a, _b, _c;
        const sendMultiples = (_a = fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.actions) === null || _a === void 0 ? void 0 : _a.sendMultiples;
        if (reusable) {
            FileService_1.default.onLocalUpload(entityType);
        }
        if (beforeSend) {
            beforeSend(sendMultiples, items, fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.actions);
        }
        else {
            (_c = (_b = fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.actions) === null || _b === void 0 ? void 0 : _b.sendMultiples) === null || _c === void 0 ? void 0 : _c.call(_b, items);
        }
    };
    const handleModalConfirm = () => {
        setIsModalOpen(false);
        setIsStreaming(true);
        const actions = {
            library: openClubLibrary,
            upload: () => {
                var _a;
                (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.openRef();
            },
            dragAndDrop: () => {
                if (!filesToUpload) {
                    return;
                }
                sendFilesToUpload(filesToUpload);
            }
        };
        activePlayerStreaming();
        confirmModalTrackingEvents();
        actions[actionName.current]();
    };
    const handleDropzoneClick = () => {
        var _a;
        if (isACandidateToUseStreaming) {
            actionName.current = 'upload';
            openModalTrackingEvents();
            setIsModalOpen(true);
        }
        else {
            (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.openRef();
        }
    };
    const handleButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!fileLibraryProvider) {
            return;
        }
        actionName.current = 'library';
        if (isACandidateToUseStreaming) {
            openModalTrackingEvents();
            setIsModalOpen(true);
        }
        else {
            openClubLibrary();
        }
    };
    const updateItem = (items) => {
        var _a;
        if (isACandidateToUseStreaming) {
            if (items) {
                actionName.current = 'dragAndDrop';
                setFilesToUpload(items);
            }
            else {
                actionName.current = 'upload';
            }
            openModalTrackingEvents();
            setIsModalOpen(true);
        }
        else if (items) {
            sendFilesToUpload(items);
        }
        else {
            (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.openRef();
        }
    };
    const renderUploadInfo = () => {
        if (maxFileSize) {
            return (0, jsx_runtime_1.jsx)(UploadInfo_1.default, { multiple: multiple, maxFileSize: maxFileSize });
        }
        return (0, jsx_runtime_1.jsx)(cosmos_1.Loading, { center: true });
    };
    const renderUploadButtons = () => {
        if (reusable) {
            return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _flex-sm-row _align-items-center", children: [fileLibraryProvider && ((0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", className: "_mr-sm-3 _mb-3 _mb-sm-0", onClick: handleButtonClick, children: t('player_backoffice.general.insert_from_backoffice') })), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "tertiary", children: t('files.submit_media') })] }) }));
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "dropzone__action__button", children: (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", children: t('files.player.insert_media') }) }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isACandidateToUseStreaming && isModalOpen && ((0, jsx_runtime_1.jsx)(PlayerModal_1.default, { addOnCost: addOnCost, bundleAddOnCost: bundleAddOnCost, onConfirm: handleModalConfirm, onClose: handleModalCancel })), (0, jsx_runtime_1.jsx)(dropzone_1.Dropzone, { ref: dropzoneRef, onDrop: updateItem, multiple: multiple, isLoaded: isConfigLoaded, inputLabel: t('files.insert_from_computer'), onClick: handleDropzoneClick, children: (0, jsx_runtime_1.jsxs)("div", { className: "dropzone__info", children: [(0, jsx_runtime_1.jsx)("div", { className: "dropzone__info__label", children: renderUploadInfo() }), renderUploadButtons()] }) })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    PlayerBackofficeStore: stores.PlayerBackofficeStore,
    marketplaceId: stores.UserStore.marketplaceId
})), (0, club_files_ui_1.UploadConsumer)())(FileVideoUpload);
